export default __webpack_public_path__ + "d7650a131b8bc502db3e91b907674a0d.svg";